<section class="form-panel" [class.active]="state.editorInFocus">
  <div class="cover" *ngIf="isGuest" (click)="authorize()"></div>
  <div class="form" [formGroup]="form">
    <div class="author">
      <div class="author-photo image image-circle image-avatar-medium">
        <on-ui-cover [cover]="avatar"></on-ui-cover>
      </div>
    </div>
    <div class="editor-wrap">
      <div class="editor-content" [class.active]="state.editorInFocus">
        <editor
          class="rich-editor" *ngIf="state.editorLoaded"
          [init]="editorConfig"
          (onFocus)="state.editorInFocus = true"
          (onBlur)="state.editorInFocus = false"
          (onKeyDown)="checkForChanges()"
          formControlName="text"
        >
        </editor>
      </div>
      <div class="smiles"></div>
    </div>
  </div>

  <div class="actions">
    <div class="toolbar">
    </div>
    <div class="button-wrap">
      <on-ui-button
        [state]="state.saveButton"
        [disabled]="!readyForSave"
        [label]="'constructor.publish'"
        class="primary"
        (onclick)="save()"
      >
      </on-ui-button>
    </div>
  </div>
</section>
